import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RegionItem } from '@phdsoft/common';
import { SectionItem } from 'projects/phdsoft/common/src/lib/models/sectionitem-info.model';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThreedService {

constructor(private http: HttpClient,) { }

  getRegions(assetId: string): Observable<RegionItem[]> {
    return this.http.get<RegionItem[]>(
        environment.API_THREED + `Regions/GetRegions/${assetId}`,
    ).pipe(
      shareReplay(1)
    )
  }

  getSections(assetId: string): Observable<SectionItem[]> {
    return this.http.get<SectionItem[]>(
        environment.API_THREED + `Sections/GetSections/${assetId}`,
    ).pipe(
      shareReplay(1)
    )
  }


}
